import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { type CompanyContextDataFragment } from '../../../../../../api/fragments/CompanyContextData';
import { useListUsersQuery } from '../../../../../../api/queries/listUsers';
import { filterUsersByCompanyContext } from '../../../../../shared/filterDataByCompany';

const useSalesPersonOptions = (
    company: Pick<CompanyContextDataFragment, 'id' | '__typename'>,
    hasNone: boolean = false
) => {
    const { t } = useTranslation('common');

    const { data, loading } = useListUsersQuery({
        fetchPolicy: 'cache-and-network',
    });

    // prepare items as a data source
    const { filteredUsers: dataSource } = useMemo(() => {
        const mappedDataSource = (data?.list?.items || []).map(item => ({ ...item, key: item.id }));

        return filterUsersByCompanyContext(company, mappedDataSource);
    }, [company, data?.list?.items]);

    return useMemo(() => {
        const salesPersonOptions = dataSource.map(user => ({
            label: user.displayName,
            value: user.id,
        }));

        return {
            salesPersonOptions: [
                hasNone && {
                    value: null,
                    label: t('common:options.none'),
                },
                ...salesPersonOptions,
            ].filter(Boolean),
            loading,
        };
    }, [dataSource, hasNone, loading, t]);
};

export default useSalesPersonOptions;
